/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsFeaturedCollection = {
  init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if(this.collection_style == 'slider') {
      this.createSlider();
    }


  },
  createSlider: function() {

    let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');

    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true
    }

   const isMobile = window.matchMedia("(max-width:  749px)").matches;
    const flkty = $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      autoPlay: false,
      draggable: true,
      cellAlign: 'left',
      wrapAround: slideData.wrapAround,
      contain: true,
      initialIndex: 0,
      arrowShape: arrowShape,
      pageDots: true,
      prevNextButtons: isMobile ? false : (slideData.products_limit > slideData.products_per_slide),
      groupCells: isMobile ? 1 : false,
      on: {
        ready: function () {
          $(featuredCollectionSlider).on('settle.flickity', function () {
            $(featuredCollectionSlider).flickity('resize');
          });
        }
      }
    }).data('flickity');
    var customControls = document.querySelector('.flickity-controls');
    if (flkty && flkty.prevButton && flkty.nextButton) {
      flkty.prevButton.element.innerHTML = `
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="55.8572" y="55.5" width="55" height="55" rx="27.5" transform="rotate(-180 55.8572 55.5)" fill="#D3DE8E"/><path d="M40.1429 29.5714C41.0108 29.5714 41.7143 28.8679 41.7143 28C41.7143 27.1321 41.0108 26.4286 40.1429 26.4286L40.1429 29.5714ZM15.4603 26.8888C14.8466 27.5025 14.8466 28.4975 15.4603 29.1112L25.4608 39.1117C26.0745 39.7254 27.0695 39.7254 27.6831 39.1117C28.2968 38.498 28.2968 37.503 27.6831 36.8893L18.7938 28L27.6831 19.1107C28.2968 18.497 28.2968 17.502 27.6831 16.8883C27.0695 16.2746 26.0745 16.2746 25.4608 16.8883L15.4603 26.8888ZM40.1429 28L40.1429 26.4286L16.5715 26.4286L16.5715 28L16.5715 29.5714L40.1429 29.5714L40.1429 28Z" fill="#084639"/></svg>
         `;
      
        flkty.nextButton.element.innerHTML = `
          <svg width="55" height="56" viewBox="0 0 55 56" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3.05176e-05" y="0.5" width="55" height="55" rx="27.5" fill="#D3DE8E"/><path d="M15.7143 26.4286C14.8464 26.4286 14.1429 27.1321 14.1429 28C14.1429 28.8679 14.8464 29.5714 15.7143 29.5714L15.7143 26.4286ZM40.3969 29.1112C41.0106 28.4975 41.0106 27.5025 40.3969 26.8888L30.3964 16.8883C29.7827 16.2746 28.7878 16.2746 28.1741 16.8883C27.5604 17.502 27.5604 18.497 28.1741 19.1107L37.0634 28L28.1741 36.8893C27.5604 37.503 27.5604 38.498 28.1741 39.1117C28.7878 39.7254 29.7827 39.7254 30.3964 39.1117L40.3969 29.1112ZM15.7143 28L15.7143 29.5714L39.2858 29.5714L39.2858 28L39.2858 26.4286L15.7143 26.4286L15.7143 28Z" fill="#084639"/></svg>
        `;
      customControls.appendChild(flkty.prevButton.element);
      customControls.appendChild(flkty.nextButton.element);
    }
    window.addEventListener("resize", () => {
      flkty.resize();
    });
  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;